import { defineComponent } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'LoaderComponent',
    props: {
        message: {
            type: String,
            required: false,
        },
        error: {
            type: String,
            required: false,
        },
        verify: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    setup(props) {
        const transactionsStore = useTransactionsStore();
        const { loadingMessage, loadingErrorMessage } = storeToRefs(transactionsStore);
        return {
            loadingMessage: props.message || loadingMessage.value,
            loadingErrorMessage: props.error || loadingErrorMessage.value,
        };
    },
});
